import { Expose, Type } from 'class-transformer';
import { BaseModel, ClonedIsoString } from '@core/data-access';

export class HdbOwnershipPropertyModel extends BaseModel {
  @Expose()
  @ClonedIsoString('dateOfPurchaseOnly')
  dateOfPurchase!: string;

  @Expose()
  dateOfPurchaseOnly!: string;

  @Expose()
  outstandingLoanBalance!: number | null;

  @Expose()
  monthlyLoanInstalment!: number | null;
}

/** Provenance MyInfo answered the group with — echoed back unchanged, never edited. */
export class HdbOwnershipModel extends BaseModel {
  @Expose()
  lastUpdated?: string;

  @Expose()
  lastUpdatedOnly?: string;

  @Expose()
  source?: string;

  @Expose()
  classification?: string;

  @Expose()
  @Type(() => HdbOwnershipPropertyModel)
  properties?: HdbOwnershipPropertyModel[];
}
